/**
 * AP-28 Nachtrag N-12 — **die Preiseinheit, eine Regel für beide Module.**
 *
 * Der Preis gilt je `priceUnit` Einheiten (`1,24 / 250 Stk`). Bis zum 13.9.2026
 * war das eine Auswahl aus 1, 100 und 1000, verteilt auf sechs Stellen; seither
 * ist es eine frei eingegebene ganze Zahl. Die Rechnung (`zeilenbetragCent`)
 * war schon immer allgemein — gesperrt war nur die Eingabe.
 *
 * Genutzt von Artikelstamm, Artikelimport, Integrations-API und Belegwesen.
 */

/** Obergrenze — „je eine Million Stück" deckt jede Kleinteil-Preisliste. */
export const PRICE_UNIT_MAX = 1_000_000

/** Vorschläge im Eingabefeld, keine Grenze. */
export const PRICE_UNIT_SUGGESTIONS = [1, 100, 1000] as const

/** Ganze Zahl von 1 bis `PRICE_UNIT_MAX`. */
export function istGueltigePreiseinheit(wert: unknown): wert is number {
  return typeof wert === 'number' && Number.isInteger(wert) && wert >= 1 && wert <= PRICE_UNIT_MAX
}
